"use client";

import { motion } from "framer-motion";

const footerLinks = {
  Company: ["About Us", "Services", "Projects", "Careers"],
  Support: ["Help Center", "Privacy Policy", "Terms", "Contact"],
  Products: ["Cooling Systems", "HVAC Solutions", "Air Coils", "Ventilation"],
};

export default function Footer() {
  return (
    <footer className="bg-[#333333] text-white">

      <div className="max-w-7xl mx-auto px-6 py-14">

        {/* Top Section */}
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4 border-b border-white/10 pb-10">

          {/* Logo */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl font-bold">
              CoolWell
            </h2>

            <p className="mt-4 text-sm leading-6 text-gray-300">
              Modern HVAC and cooling solutions for homes, offices,
              and industrial projects.
            </p>
          </motion.div>

          {/* Links */}
          {Object.entries(footerLinks).map(([title, links], idx) => (
            <motion.div
              key={title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: idx * 0.1, duration: 0.5 }}
              viewport={{ once: true }}
            >
              <h3 className="mb-4 text-lg font-semibold">
                {title}
              </h3>

              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link}>
                    <a
                      href="#"
                      className="text-sm text-gray-300 transition hover:text-white"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        {/* Contact Info */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="flex flex-col gap-4 py-8 text-sm text-gray-300 md:flex-row md:items-center md:justify-between"
        >

          <p>
            📍 Lahore, Pakistan
          </p>

          <p>
            📞 +92 300 1234567
          </p>

          <p>
            ✉️ info@coolwellcoils.com
          </p>

        </motion.div>

        {/* Bottom */}
        <div className="flex flex-col gap-4 border-t border-white/10 pt-6 text-sm text-gray-400 md:flex-row md:items-center md:justify-between">

          <p>
            © 2026 CoolWell Coils. All rights reserved.
          </p>

          <div className="flex items-center gap-5">
            <a href="#" className="transition hover:text-white">
              Privacy
            </a>

            <a href="#" className="transition hover:text-white">
              Terms
            </a>

            <a href="#" className="transition hover:text-white">
              Sitemap
            </a>
          </div>

        </div>

      </div>
    </footer>
  );
}